import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 25,
    marginTop: 100,
    maxWidth: 570,
    width: "100%",
    marginHorizontal: "auto",
    alignItems: "center",
  },

  card: {
    width: "40%",
    height: 400,
    minWidth: 360,
    flex: 1,
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  cardTitle: {
    flex: 1,
    alignItems: "center",
    marginTop: 50,
    textTransform: "uppercase",
    color: "#077a97",
    fontSize: 18,
    fontWeight: "bold",
  },

  cardPassword: {
    marginTop: 50,
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "center",
    fontWeight: "500",
  },

  cardFooter: {
    flex: 1,
    marginBottom: 25,
    marginTop: 87,
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: 10,
  },

  button1: {
    alignItems: "center",
    padding: 20,
    height: 56,
    width: 150,
    backgroundColor: "#fff",
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 4,
  },

  buttonText1: {
    textTransform: "uppercase",
    color: "#077A97",
  },

  button2: {
    alignItems: "center",
    padding: 20,
    height: 56,
    width: 150,
    backgroundColor: "#077A97",
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 4,
  },

  buttonText2: {
    textTransform: "uppercase",
    color: "#fff",
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default styles;
